import {onClick} from '../abstract/helpers.js';

export class FollowMenu {
  constructor() {
    if(document.querySelector('.follow-menu-style-1')) {

      window.addEventListener('scroll', function(event) { 
        let el = document.querySelector('.follow-menu-style-1');
        let el2 = document.querySelector('.menu-style-1');
        let windowHeight = window.innerHeight;
  
        let viewportOffset = el2.getBoundingClientRect();  //  returns the size of an element and its position relative to the viewport
        let top = viewportOffset.top;  //  get the offset top
        console.log(top);
        console.log(windowHeight);
        if(top < 0){  //  if the top offset is less than the window height
          el.classList.add('visible');
        } else{
          el.classList.remove('visible');
        }
      });



    }
  }
}
